<template>
  <div class="fshr-tripCard" @click="redirectTo(hotel.detail_link)" :class="offerClass(hotel)">
    <div class="fshr-tripCard__imgWrapper">
      <SimpleGallery :images="hotel.images" :alt="hotel.name"></SimpleGallery>

      <CardBadge v-if="hotel.offer" :label="hotel.offer.title" v-tooltip="offerTooltip()" />
      <FavoritesButton
        class="fshr-tripCard__favoritesBtn"
        :isFavorite="is_favorite"
        @favoriteChange="addToFavorite($event, hotel)"
        v-tooltip="
          is_favorite
            ? getBasicTooltip(getTranslation('odebratZOblibenych'))
            : getBasicTooltip(getTranslation('pridatDoOblibenych'))
        "
      />
    </div>
    <div class="fshr-tripCard__header">
      <a
        target="_blank"
        :href="hotel.detail_link"
        class="fshr-tripCard__title-link"
      >
        <h3 class="fshr-tripCard__title" v-if="hotel.name">
          {{ hotel.name }}
        </h3>
      </a>
      <div class="fshr-tripCard__rating" v-if="hotel.rating">
        <StarRating
          :rating="hotel.rating.count"
          :type="hotel.rating.type"
          :isSelectable="false"
        />
      </div>
      <LocationBreadcrumbs v-if="hotel.location" :locations="hotel.location" />
    </div>
    <div class="fshr-tripCard__content">
      <DateRangeSlot
        v-if="hotel.date"
        :range="hotel.date"
        :translations="translations"
      />
      <div
        class="fshr-tripCard__distanceFood"
        v-if="hotel.distance || hotel.strava"
      >
        <span v-if="hotel.distance" class="fshr-tripCard__distance">
          {{ hotel.distance_label }}: {{ getKilometers(hotel.distance) }}
        </span>
        <span v-if="hotel.strava" class="fshr-tripCard__food">
          {{ getTranslation("food_label") }}: {{ hotel.strava }}
        </span>
      </div>
      <TripServices v-if="hotel.extras" :tripServices="hotel.extras" :serverurl="serverurl" />
    </div>
    <div class="fshr-tripCard__priceWrapper" v-if="hotel.price.new_price > 0 && !hotel.preparing">
      <div class="fshr-tripCard__priceRow fshr-tripCard__priceRow--feat">
        <div class="fshr-tripCard__priceLabel">
          {{ getTranslation("total_label") }}:
        </div>
        <div class="fshr-tripCard__priceValue">
          <div
            class="fshr-tripCard__priceValueOld"
            v-if="hotel.price.old_price"
          >
            {{
              hotel.price.old_price
                | formatCurrency(hotel.price.currency, false)
            }}
            <span class="fshr-tripCard__currency">{{
              hotel.price.currency
            }}</span>
          </div>
          <div class="fshr-tripCard__priceValueCurrent">
            {{
              hotel.price.new_price
                | formatCurrency(hotel.price.currency, false)
            }}
            <span class="fshr-tripCard__currency">{{
              hotel.price.currency
            }}</span>
          </div>
        </div>
      </div>
      <div
        class="fshr-tripCard__priceRow fshr-tripCard__priceRow--caption"
        v-if="hotel.price.previous_price"
      >
        <div class="fshr-tripCard__priceLabel">
          {{ getTranslation("termin_label1") }}:
        </div>
        <div class="fshr-tripCard__priceValue">
          {{
            hotel.price.previous_price
              | formatCurrency(hotel.price.currency, false)
          }}
          <span class="fshr-tripCard__currency">{{
            hotel.price.currency
          }}</span>
        </div>
      </div>
      <div
        class="fshr-tripCard__priceRow fshr-tripCard__priceRow--caption"
        v-if="hotel.price.next_price"
      >
        <div class="fshr-tripCard__priceLabel">
          {{ getTranslation("termin_label2") }}:
        </div>
        <div class="fshr-tripCard__priceValue">
          {{
            hotel.price.next_price | formatCurrency(hotel.price.currency, false)
          }}
          <span class="fshr-tripCard__currency">{{
            hotel.price.currency
          }}</span>
        </div>
      </div>
    </div>
    <div class="fshr-tripCard__actions" v-if="!hotel.preparing">
      <Button
        color="link"
        href="#popup-ceniky"
        class="fshr-tripCard__moreBtn js-popupWindow--show"
        target="_blank"
        :attdata="{
          'data-dynamicload-id': hotel.id,
          'data-dynamicload': hotel.prices_link,
        }"
        rel="noopener noreferrer"
      >
        {{ getTranslation("zobrazit") }}
      </Button>
      <Button
        iconRight="icon-sipka_prava"
        :href="hotel.detail_link"
        class="fshr-tripCard__orderBtn"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ getTranslation("mam_zajem") }}
      </Button>
    </div>
    <div class="fshr-tripCard__preparingWrapper" v-if="hotel.preparing">
      <div class="fshr-preparingTrip">
        <i class="fshr-icon fshr-icon--calendar"></i>
        <h3>{{getTranslation("tentoZajezdChystame")}}</h3>
        <form class="js-form" data-callbyvalid="runWatchDog" :action="api_url_watchdog" :data-id="hotel.id" data-type="kapacita" v-if="!logged">
          <div class="form-field">
            <input type="email" :placeholder="getTranslation('zadejteEmail')" class="form-control js-watchDogEmail" data-form-required="true">
          </div>
          <button type="submit" class="fshr-button fshr-button--iconed fshr-icon fshr-icon--caretRight fshr-button--moreImportance fshr-button--big fshr-button--fullWidth">{{getTranslation("dejteMiVedet")}}</button>
        </form>
        <form :action="api_url_watchdoglogged" v-else>
          <input type="hidden" name="id" :value="hotel.id" />
          <input type="hidden" name="type" value="kapacita" />
          <button type="submit" class="fshr-button fshr-button--iconed fshr-icon fshr-icon--caretRight fshr-button--moreImportance fshr-button--big fshr-button--fullWidth">{{getTranslation("dejteMiVedet")}}</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "./common/StarRating.vue";
import FavoritesButton from "./common/FavoritesButton.vue";
import TripServices from "./common/TripServices.vue";
import Button from "./common/Button.vue";
import CardBadge from "./common/CardBadge.vue";
import LocationBreadcrumbs from "./common/LocationBreadcrumbs.vue";
import DateRangeSlot from "./common/DateRangeSlot.vue";
import distanceMixin from "../mixins/distanceMixin";
import myHelper from "../helpers/myHelper";
import axios from "axios";
import SimpleGallery from "./SimpleGallery";

export default {
  name: "trip-card",
  components: {
    SimpleGallery,
    StarRating,
    FavoritesButton,
    DateRangeSlot,
    LocationBreadcrumbs,
    TripServices,
    Button,
    CardBadge,
  },

  props: {
    hotel: {
      type: Object,
      required: true,
    },
    api_url_addtofavorite: {
      default: "/JSON/addtofavorite.json",
      type: String,
      required: false,
    },
    api_url_watchdoglogged: {
      default: "",
      type: String,
      required: false
    },
    api_url_watchdog: {
      default: "/moje-nev-dama/checkLogin",
      type: String,
      required: false
    },
    logged: {
      type: Boolean,
      required: false,
      default: false,
    },
    serverurl: {
      required: false,
      type: String,
      default: "/",
    },
    translations: {
      default() {
        return {
          total_label: "Celkem za všechny",
          food_label: "Strava",
          termin_label1: "Předchozí termín",
          termin_label2: "Následující termín",
          zobrazit: "Zobrazit další termíny",
          mam_zajem: "MÁm Zájem",
        };
      },
    },
  },
  data: function () {
    return {
      is_favorite: false
    }
  },
  mounted: function () {
    this.is_favorite = this.hotel.is_favorite;
  },
  methods: {
    offerTooltip: function (){
      if(this.hotel.offer.hasOwnProperty("description")){
        return this.getBasicTooltip(this.hotel.offer.description);
      }
      return false;
    },
    blankMethod: function () {
      return true;
    },
    redirectTo: function (link) {
      if (window.innerWidth < 800) {
        window.location.href = link;
      }
    },
    offerClass: function (hotel) {
      if(hotel.hasOwnProperty("offer") && hotel.offer !== null && hotel.offer.hasOwnProperty("class")){
        return [hotel.offer.class];
      }else{
        return [];
      }
    },
    addToFavorite: function (favorite, hotel) {
      axios
        .post(this.api_url_addtofavorite, {
          id: hotel.id,
        })
        .then((payload) => {
          if (payload.status === 200 && payload.data.status === "OK") {
            let payload = {
              hotel: hotel,
              favorite: favorite,
            };

            let countEl = document.querySelector(".fshr-menuFavorite");
            let count = parseInt(countEl.innerText);

            if (this.is_favorite) {
              count--;
            } else {
              count++;
            }

            countEl.innerText = count;

            this.$store.commit("setHotelFavorite", payload);
            this.is_favorite = payload.favorite;
          }
        })
        .catch((error) => {
          console.error(error);
          alert("Failed to add to favorite");
        });
    },
  },
  mixins: [distanceMixin, myHelper],
};
</script>

<style lang="less">
  @import './../less/variables';
  @import './../../../../../Content/css/components/component-trip-card';
</style>
